import { Database, EyeOff, ShieldCheck, Trash2 } from "lucide-react";

export function PrivacyPage() {
  return (
    <div className="page page--privacy">
      <section className="page-intro content-frame">
        <p className="eyebrow"><ShieldCheck aria-hidden="true" size={16} /> Adatkezelés</p>
        <h1>Átlátható és takarékos adatkezelés</h1>
        <p>
          Ez a V1-hez tervezett rövid összefoglaló. A Firebase élesítése előtt a végleges jogi
          tájékoztató és az adatkezelő adatai külön ellenőrzést kapnak.
        </p>
      </section>

      <section className="section content-frame privacy-grid" aria-label="Adatkezelési alapelvek">
        <article>
          <Database aria-hidden="true" size={28} />
          <h2>Csak a játékhoz szükséges adatok</h2>
          <p>
            A profil technikai azonosítóját, nyilvános játékosnevet, a pontszámot és a játék
            befejezési idejét tervezzük tárolni.
          </p>
        </article>
        <article>
          <EyeOff aria-hidden="true" size={28} />
          <h2>A Google-adatok nem nyilvánosak</h2>
          <p>
            A toplistán külön választott becenév szerepel. E-mail-cím, Google-név és profilkép nem
            jelenik meg nyilvánosan.
          </p>
        </article>
        <article>
          <Trash2 aria-hidden="true" size={28} />
          <h2>Vendégadatok megőrzése</h2>
          <p>
            Az anonim és a Google-fiók külön marad. A 90 napja inaktív vendégprofil, annak
            eredményei és toplista-bejegyzése ütemezetten törölhető.
          </p>
        </article>
      </section>

      <section className="privacy-detail">
        <div className="content-frame prose">
          <h2>Tervezett felhasználói jogok</h2>
          <p>
            A bejelentkezett játékos megtekintheti a saját alapadatait és eredményeit. Más játékos
            privát rekordját nem olvashatja, nem módosíthatja és nem törölheti. A törlési folyamatot
            az élesítés előtt külön felülettel és ellenőrizhető Firestore-szabályokkal egészítjük ki.
          </p>
          <h2>Toplista</h2>
          <p>
            A nyilvános toplista csak a választott vagy generált játékosnevet, a játékostípust, a
            legjobb pontszámot és annak időpontját tartalmazza. Firebase UID vagy fiókadat nem része a
            nyilvános nézetnek.
          </p>
          <h2>Jelenlegi állapot</h2>
          <p>
            A hitelesítés, a profil- és pontszámtárolás, a toplista és a 90 napos vendégadat-törlés
            helyi fejlesztői változata elkészült. Hosztolt adatkezelés csak a biztonsági és jogi
            ellenőrzések, majd külön kiadási jóváhagyás után aktiválódik.
          </p>
        </div>
      </section>
    </div>
  );
}
